import { createSelector } from '@reduxjs/toolkit'

import { getSecurity } from '../../root.selectors'

export const getSecurityIPAccesses = createSelector(getSecurity, (security) => security.ipAccesses)
